export const CREATE_BIKE_HPI_CHECK = 'CREATE_BIKE_HPI_CHECK';
export const CREATE_BIKE_HPI_CHECK_SUCCESS = 'CREATE_BIKE_HPI_CHECK_SUCCESS';
export const CREATE_BIKE_HPI_CHECK_FAILURE = 'CREATE_BIKE_HPI_CHECK_FAILURE';

export const GET_BIKE_HPI_CHECK = 'GET_BIKE_HPI_CHECK';
export const GET_BIKE_HPI_CHECK_SUCCESS = 'GET_BIKE_HPI_CHECK_SUCCESS';
export const GET_BIKE_HPI_CHECK_FAILURE = 'GET_BIKE_HPI_CHECK_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/constants/bike_hpi_check.constants.js